var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9929 0C18.6221 0 23.9953 5.37321 23.9953 12.0024C23.9953 18.6315 18.6221 24 11.9976 24C5.36849 24 3.10941e-06 18.6268 3.10941e-06 12.0024C-0.00471851 5.37321 5.36848 0 11.9929 0Z",
    fill: "#8247E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1486",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 16,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7749 5.19006H4.04721V18.9725H19.7749V5.19006Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9268 9.38707C15.6387 9.22181 15.2704 9.22181 14.9447 9.38707L12.65 10.7469L11.0918 11.611L8.8396 12.9661C8.55158 13.1313 8.1833 13.1313 7.85751 12.9661L6.09634 11.8943C5.80832 11.729 5.60529 11.3985 5.60529 11.0302V8.97157C5.60529 8.64105 5.77055 8.31526 6.09634 8.10751L7.85751 7.0782C8.14553 6.91294 8.51381 6.91294 8.8396 7.0782L10.6008 8.15001C10.8888 8.31526 11.0918 8.64578 11.0918 9.01406V10.3739L12.65 9.46734V8.06974C12.65 7.73922 12.4847 7.41343 12.1589 7.20568L8.8821 5.26982C8.59408 5.10456 8.22579 5.10456 7.9 5.26982L4.54293 7.24818C4.21714 7.41343 4.05188 7.74395 4.05188 8.06974V11.9367C4.05188 12.2673 4.21714 12.5931 4.54293 12.8008L7.86223 14.7367C8.15025 14.9019 8.51853 14.9019 8.84433 14.7367L11.0965 13.4193L12.6547 12.5128L14.9069 11.1955C15.1949 11.0302 15.5632 11.0302 15.889 11.1955L17.6501 12.2248C17.9382 12.39 18.1412 12.7205 18.1412 13.0888V15.1474C18.1412 15.478 17.9759 15.8038 17.6501 16.0115L15.9315 17.0408C15.6435 17.2061 15.2752 17.2061 14.9494 17.0408L13.1835 16.0115C12.8955 15.8462 12.6924 15.5157 12.6924 15.1474V13.8301L11.1343 14.7367V16.0965C11.1343 16.427 11.2996 16.7528 11.6254 16.9606L14.9447 18.8964C15.2327 19.0617 15.601 19.0617 15.9268 18.8964L19.2461 16.9606C19.5341 16.7953 19.7371 16.4648 19.7371 16.0965V12.187C19.7371 11.8565 19.5718 11.5307 19.2461 11.3229L15.9268 9.38707Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonIcon);
export default __webpack_public_path__ + "static/media/polygonIcon.faa720467458a25f4c89fd9b67e79d8c.svg";
export { ForwardRef as ReactComponent };